module.exports = __webpack_public_path__ + "static/media/login-logo.573393ba.png";